import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Badge from '../components/Badge';
import Card from '../components/Card';
import Input from '../components/Input';
import Table from '../components/Table';
import { crmService } from '../services/crmService';
import type { Empresa, KanbanStatus } from '../types';

export default function EmpresasPage() {
  const [items, setItems] = useState<Empresa[]>([]);
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState<KanbanStatus | 'all'>('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    crmService
      .listEmpresas({ search, status })
      .then(setItems)
      .finally(() => setLoading(false));
  }, [search, status]);

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-black">Empresas</h1>
      <Card className="grid gap-3 md:grid-cols-[1fr_240px]">
        <Input label="Buscar empresa, website ou telefone" value={search} onChange={(e) => setSearch(e.target.value)} />
        <label className="text-sm font-semibold">
          <span className="mb-1 block text-slate-500">Status</span>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value as KanbanStatus | 'all')}
            className="h-12 w-full rounded-xl border border-borderLight bg-cardLight px-3 dark:border-borderDark dark:bg-cardDark"
          >
            <option value="all">Todos</option>
            <option value="Captadas">Captadas</option>
            <option value="Em análise">Em análise</option>
            <option value="Contato iniciado">Contato iniciado</option>
            <option value="Retornaram">Retornaram</option>
          </select>
        </label>
      </Card>
      <Table
        loading={loading}
        data={items}
        columns={[
          {
            key: 'nome_empresa',
            header: 'Empresa',
            render: (r) => (
              <div>
                <Link className="font-semibold text-primary" to={`/empresas/${r.id}`}>
                  {r.nome_empresa}
                </Link>
                <p className="text-xs text-slate-500">{r.website}</p>
              </div>
            )
          },
          { key: 'telefone', header: 'Telefone' },
          { key: 'endereco', header: 'Endereço' },
          { key: 'rating', header: 'Rating' },
          { key: 'reviews', header: 'Reviews' },
          {
            key: 'retornou',
            header: 'Retornou',
            render: (r) => <Badge variant={r.retornou ? 'success' : 'neutral'}>{r.retornou ? 'Sim' : 'Não'}</Badge>
          },
          { key: 'status_kanban', header: 'Kanban' }
        ]}
      />
    </div>
  );
}
